import React, { useEffect, useState } from "react";

import './user.css'

// Images //
import { images } from "../../assets/index";

// Component //
import {
  FormInput,
  PageHeading,
  ButtonComp,
  Loader,
} from "../../common/components/index";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// Actions //
import {
  receivedError,
  responseRecived,
  requestSent,
} from "../../redux/actions/utilsActions";

// Hooks //
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getModuleApi } from "../../api/sideBarApi";
import { editUsersApi, getSingleUserApi } from "../../api/users";

const EditUser = () => {
  // Hooks //
  const { userToken, user } = useSelector((state) => state.user);
  const [searchParams] = useSearchParams();
  const user_id = searchParams.get("user_id");

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    address: "",
    phone_number: "",
    signatory_on_account: "",
    module: [],
    user_id
  });
  const [respMessage, setRespMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [modules, setModules] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [onPageLoader, setOnPageLoader] = useState(false);

  useEffect(() => {
    getModules()
    getCurentUser()
  }, [])

  const getModules = async () => {
    try {
      dispatch(requestSent());
      const data = await getModuleApi(userToken);
      setModules(data.contractor_modules);
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error))
      dispatch(responseRecived());
    }
  }

  const getCurentUser = async () => {
    try {
      dispatch(requestSent());
      const { data } = await getSingleUserApi(userToken, user_id);
      setFormData(prev => ({
        ...prev,
        fullname: data.fullname,
        email: data.email,
        phone_number: data.phone_number,
        signatory_on_account: data.signatory_on_account,
        address: data.address
      }))
      data.contractor_modules.forEach((item) => {
        const obj = {
          target: {
            value: item.module_type.id,
            name: item.module_type.name,
            checked: true,
          }
        }
        handleSelectFeature(obj)
      })
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
    }
  }
  // Handler //
  const edituserHendler = async () => {
    try {
      if (
        !formData.fullname ||
        !formData.address ||
        !formData.email ||
        !formData.phone_number ||
        !formData.signatory_on_account ||
        !formData.module.length ||
        !formData.user_id
      ) {
        alert("!!Please fill all the fields!!");
        return;
      }
      setOnPageLoader(true);
      setError("");
      dispatch(requestSent());
      const data = await editUsersApi(userToken, formData);
      setRespMessage(data.message);
      setModalShow(true);
      dispatch(responseRecived());
    } catch (error) {
      console.log("Edit User Page error::", error);
      dispatch(receivedError(error));
      setError(error);
    } finally {
      setOnPageLoader(false);
    }
  };

  const modalHendler = () => {
    setModalShow(false);
    navigate("/users");
  };

  const handleSelectFeature = (e) => {
    const moduleId = e.target.value;
    const moduleName = e.target.name;
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedValues(prev => [...prev, moduleName]);
      setFormData(prev => ({
        ...prev,
        module: [
          ...prev.module,
          moduleId,
        ]
      }));
    } else {
      setSelectedValues(prev => prev.filter(p => p !== moduleName))

      setFormData({
        ...formData,
        module: formData.module.filter(m => m !== moduleId)
      });
    }
  };
  // Modal //
  const CustomModal = () => {
    return (
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
      >
        <Modal.Body>
          <div className="allert_img_cont">
            <img src={images.success} alt="" />
            <h2>User Updated</h2>
            <p>{respMessage}</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button className="orange_btn btn_style" onClick={modalHendler}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  if (onPageLoader) {
    return <Loader />;
  }

  return (
    <>
      <CustomModal />
      <PageHeading title={"Add A New User"} />
      <div id="add-subcontractor" className="right-sec_cont">
        <div>
          <h2>User Details</h2>
          <FormInput
            width={"30vw"}
            lable="Name"
            placeholder={"Enter User Name"}
            onchange={(value) =>
              setFormData({
                ...formData,
                fullname: value,
              })
            }
            value={formData.fullname}
            type={"text"}
            error={error?.error_key === "fullname" ? true : false}
          />
          <FormInput
            width={"30vw"}
            lable="Email"
            placeholder={"Enter Email"}
            onchange={(value) =>
              setFormData({
                ...formData,
                email: value,
              })
            }
            value={formData.email}
            type={"text"}
            error={error?.error_key === "email" ? true : false}
          />

          <FormInput
            width={"30vw"}
            lable="Mobile Number"
            placeholder={"Enter Mobile No."}
            onchange={(value) => {
              setFormData({
                ...formData,
                phone_number: value,
              });
            }}
            value={formData?.phone_number}
            type={"number"}
            error={error?.error_key === "phone_number" ? true : false}
          />

          <FormInput
            width={"30vw"}
            lable="Address"
            placeholder={"Enter Address"}
            onchange={(value) =>
              setFormData({
                ...formData,
                address: value,
              })
            }
            value={formData.address}
            type={"text"}
            error={error?.error_key === "address" ? true : false}
          />

          <div className="w-100">
            <label style={{ fontSize: '16px', marginBottom: '.5rem' }}>Features Allowed:</label> <br />
            <div className="dropdown">
              <button style={{ marginBottom: '.5rem' }} className="btn btn-primary w-100" type="button">Select Features Allowed</button>
              <div className="dropdown-content">
                {
                  modules.length && modules.map(m => {
                    const moduleId = m.module_type.id;
                    const moduleName = m.module_type.name;
                    return (
                      <label key={m.id}>
                        <input type="checkbox" checked={selectedValues && selectedValues.some(sv => sv === moduleName)} value={moduleId} name={moduleName} onChange={handleSelectFeature} />
                        &nbsp;{moduleName}
                      </label>
                    )
                  })
                }
              </div>
            </div>
            <div className="w-100 d-flex" style={{ flexWrap: 'wrap', maxWidth: '25rem' }}>
              {
                selectedValues.map(sv => {
                  return (
                    <button className="btn btn-primary selected-module-button m-1" key={sv}>
                      {sv}
                    </button>
                  )
                })
              }
            </div>
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
              onChange={(e) => setFormData(prev => {
                return {
                  ...prev,
                  signatory_on_account: e.target.checked
                }
              })}
            />
            <label className="form-check-label" htmlFor="exampleCheck1">
              Signatory On Account
            </label>
          </div>

          {error ? <p className="err_message">*{error?.error_message}</p> : ""}
          <ButtonComp
            onClick={edituserHendler}
            title={"Edit User"}
            width={"30vw"}
          />
        </div>
      </div>
    </>
  );
};

export default EditUser;
